import { cn } from "@app/ui";

import { useI18n } from "../../lib/useI18n.js";

export type OrganizeTab = "topics" | "calendars" | "labels";

export const ORGANIZE_TABS: OrganizeTab[] = ["topics", "calendars", "labels"];

/** Segmented control switching the active Organize panel. */
export function OrganizeTabs({ tab, onChange }: { tab: OrganizeTab; onChange: (tab: OrganizeTab) => void }) {
  const { t } = useI18n();
  const labelFor = (key: OrganizeTab) =>
    t(key === "topics" ? "common.topics" : key === "calendars" ? "common.calendars" : "common.labels");
  return (
    <div role="tablist" className="flex w-fit gap-1 rounded-lg border border-border bg-muted p-1">
      {ORGANIZE_TABS.map((key) => (
        <button
          key={key}
          type="button"
          role="tab"
          aria-selected={tab === key}
          onClick={() => onChange(key)}
          className={cn(
            "rounded-md px-3 py-1.5 text-sm transition-colors",
            tab === key ? "bg-background font-medium shadow-sm" : "text-muted-foreground hover:text-foreground",
          )}
        >
          {labelFor(key)}
        </button>
      ))}
    </div>
  );
}
